export default "__VITE_ASSET__CIpcKpNY__"